import { storyblokEditable } from '@storyblok/react'
import {Disclosure} from '@headlessui/react'
import {ChevronUpIcon} from '@heroicons/react/20/solid'
import Content from '@/Components/Content'

export default ({ blok }) => {
    return (
        <div className="py-10"
             {...storyblokEditable(blok)}
        >
            <h2 className="text-center mb-10 lg:mb-20 text-neutral-800 text-xl lg:text-4xl font-medium">{blok.heading}</h2>

            <div>
                {blok.questions.map((faq, i) => (
                    <Disclosure key={faq._uid} as="div" className="border-t-neutral-200 border-t">
                        {({ open }) => (
                            <>
                                <Disclosure.Button className="block w-full text-left text-lg text-zinc-800 border-none outline-none ring-0">
                                    <div className="flex w-full items-center px-2.5 py-3.5 lg:py-6 justify-between outline-none">
                                        <span>{faq.question}</span>
                                        <ChevronUpIcon
                                            className={`${
                                                open ? '' : 'transform rotate-180'
                                            } w-6 h-6 lg:h-8 lg:w-8 text-black`}
                                        />
                                    </div>
                                </Disclosure.Button>
                                <Disclosure.Panel className="pl-16 pr-24 pt-2 pb-10 text-xs lg:text-base text-gray-600">
                                    <Content content={faq.answer} />
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>
                ))}
            </div>
        </div>
    )
};
